import api from './api';

const resource = 'Referral/';

export const me = async () => {
  return await api.get(resource + 'Me');
};

export const history = async (query) => {
  return await api.get(resource + 'History' + query);
};

export const ledger = async () => {
  return await api.get(resource + 'Ledger');
};

export const shareSms = async (body) => {
  return await api.post(resource + 'ShareSms', body);
};

export const shareEmail = async (body) => {
  return await api.post(resource + 'ShareEmail', body);
};

export const validate = async (code) => {
  return await api.get(resource + 'Validate?code=' + encodeURIComponent(code));
};

// Kayıt sırasında kod girmeyen davet edilen restoran, davet eden kodunu
// dashboard'dan sonradan ekler. body { code } (admin için { companyid, code }).
export const applyCode = async (body) => {
  return await api.post(resource + 'ApplyCode', body);
};

const referralApi = {
  me,
  history,
  ledger,
  shareSms,
  shareEmail,
  validate,
  applyCode,
};

export default referralApi;
